module.exports = __webpack_public_path__ + "img/solarroof_mob@2x.0688663.jpg";